import React from 'react';
import logo from "../src/Images/logo.png"
import bottomImg from "../src/Images/bottomImg.png"

function ErrorPage() {
  const styles = {
      errorPage: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif'
      },
      logoImg: {
          maxHeight: '17rem'
      },
      errorText: {
          fontSize: '2.5rem',
          color: 'red',
          fontWeight: 'bold',
          margin: '1rem 0'
      },
      oopsText: {
          fontSize: '1.5rem',
          color: 'red',
          fontWeight: 'bold',
          marginBottom: '1rem'
      },
      footerImg: {
          width: '100%' // Adjust this value based on your footer image's aspect ratio
      }
  };

  return (
      <div style={styles.errorPage}>
          <div>
              <img src={logo} alt="Government of Haryana Logo" style={styles.logoImg} />
          </div>
          <p style={styles.errorText}>
              Error 404
          </p>
          <p style={styles.oopsText}>
              Oops... Page not found
          </p>
          <div>
              <img src={bottomImg} alt="Decorative Footer Image" style={styles.footerImg} />
          </div>
      </div>
  );
}

export default ErrorPage;